import { Injectable, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Access } from '../Utilities/enum';
import { AuthStore } from 'src/app/store/authorization/auth.store';

export interface UserModel {
  UserId: number;
  IqviaId: string;
  RoleId: number;  
}

export interface AccessModel {
  ScreenId: number;
  FunctionId: number;
  Permission: number;
}

@Injectable({
  providedIn: 'root'
})
export class UserAccessService {
  private readonly authStore = inject(AuthStore);
  userAccessData$ = toObservable(this.authStore.userAccessData);
  
  constructor(private http: HttpClient) {
  }

  getUserAccessByUserId(userId: string): Observable<UserModel[]> {
    return this.http.get<UserModel[]>(AppConfig.appsettings.apiRoot + '/UserAccess?userId=' + userId)
      .pipe(catchError(this.handleError));
  }

  setUserAccessData(data: UserModel[]) {
    this.authStore.setUserAccessData(data);
  }

  getuserPermissionData(roleId: number): Observable<AccessModel[]> {
    return this.http.get<AccessModel[]>(AppConfig.appsettings.apiRoot + '/UserPermission?roleId=' + roleId)
      .pipe(catchError(this.handleError));
  }

  
  /**
   * Gets the permission for a given screen and function.
   * @param screenId The screen ID to check.
   * @param functionId The function ID to check.
   * @returns Access.NoAccess | Access.Read | Access.ReadWrite
   */

  public getPermission(ScreenId: number, FunctionId: number): Access {
    let accessPermission = Access.NoAccess;
    let permissions = this.authStore.getPermission(ScreenId, FunctionId);  

    if (permissions) {
      try {
        let permissionArray = typeof permissions === 'string' ? JSON.parse(permissions) : permissions;
        let matchedPermission = permissionArray.find((p: any) => p.ScreenId === ScreenId && p.FunctionId === FunctionId);
        accessPermission = matchedPermission ? matchedPermission.Permission : Access.NoAccess;
      } catch (error) {
        console.error('Failed to parse permissions:', error);
      }
    }
    
    return accessPermission;
  }
  
  public GetUserPermissionByRoleId(roleId: number): Observable<AccessModel[]> {
    return this.http.get<AccessModel[]>(AppConfig.appsettings.apiRoot + '/GetUserPermissionByRoleId?roleId=' + roleId)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: any) {
    console.error(error.message || error);
    return throwError(() => error.message || error);
  }
}
